import { render, staticRenderFns } from "./productionCapacitySummaryWidget.vue?vue&type=template&id=3bcb21df&scoped=true&"
import script from "./productionCapacitySummaryWidget.vue?vue&type=script&lang=js&"
export * from "./productionCapacitySummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./productionCapacitySummaryWidget.vue?vue&type=style&index=0&id=3bcb21df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb21df",
  null
  
)

export default component.exports